import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import { events } from '#utilities/js/lightboxes/lightbox.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import { elements } from '../../../styles.js'
import { getCurrent, resetSelected, setSelected } from './item.js'
import { stopImmediatePropagation } from '@mailobj-browser/front/js/events/hooks/hooks.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import click from '@mailobj-browser/front/js/events/types/click.js'

const { open } = events

const onOpen = object(listener, {
  type: open,
  passive,
  task: (
    opener,
    { detail: dropdown }
  ) => {
    const template = one('template', opener)
    const { dataset } = template
    const { url } = dataset
    const dropdownList = one(`.${elements.dropdown_list}`, dropdown)
    const items = all(`.${elements.dropdown_item}`, dropdownList)

    if (!url && getCurrent(template) >= 0) {
      const indexCurrent = getCurrent(template)
      const item = items[indexCurrent]
      resetSelected(dropdownList)
      setSelected(item.firstChild)
    }
  }
})

// NOTE: On intercepte le click pour éviter que le menu responsive ne se ferme quand on déroule un dropdown
const onClick = object(listener, {
  type: click,
  hooks: array([
    stopImmediatePropagation
  ]),
  task: () => { },
})

export default button => {
  onOpen.listen(button)
  onClick.listen(button)
}
